import React from 'react';
import { Container } from 'semantic-ui-react';
import AuthTab from './AuthTab.js';
import { ConfirmSignUp, ResetPassword } from './Forms';

// TODO temporary visibility fix here!
// TODO this should actually be handled by router?
const MyAuth = (props) => {
  return (
    [
      '/signin',
      '/signup',
      '/forgotpassword',
      '/resetpassword',
      '/confirm',
      '/register'
    ].includes(props.route) &&
      <Container text>
        {
          ['/signin', '/signup', '/forgotpassword', '/register'].includes(props.route) &&
            <AuthTab
              onTabChange={props.onTabChange}
              onSignIn={props.onSignIn}
              onSignUp={props.onSignUp}
              onForgotPassword={props.onForgotPassword}
              error={props.error}
              success={props.success}
              showConfirmationCode={props.showConfirmationCode}
            />
        }
        {
          props.route === '/confirm' &&
            <ConfirmSignUp
              onSubmit={props.onConfirmSignUp}
              onResendCode={props.onResendCode}
              error={props.error}
            />
        }
        {
          props.route === '/resetpassword' &&
            <ResetPassword
              onSubmit={props.onResetPassword}
              onResendCode={props.onResendCode}
              error={props.error}
            />
        }

      </Container>

  );
};

export default MyAuth;



// WEBPACK FOOTER //
// ./src/public/components/Auth/index.js